import { render, staticRenderFns } from "./FormMyProfile.vue?vue&type=template&id=4f057236&scoped=true&"
import script from "./FormMyProfile.vue?vue&type=script&lang=js&"
export * from "./FormMyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f057236",
  null
  
)

export default component.exports